import "@mshop-ui/core-web-components/dist/ui-button";
import React from "react";
import { FormControl, Checkbox } from "react-bootstrap";
import { TrackingActions } from "../../actions/TrackingActions";
import WebComponentAdapter from "../../../app/components/WebComponentAdapter";

const UiButton = WebComponentAdapter("ui-button");

type Tags = {
	source?: string;
	checked?: any;
};
export type TrackableProps = {
	tags?: Tags;
	innerRef?: any;
	onClick?: (...args: any[]) => any;
	onChange?: (...arg0: any[]) => any;
	children?: any;
	onSelect?: (...arg0: any[]) => any;
	onBlur?: (...arg0: any[]) => any;
	//other props
	[otherKey: string]: any;
};

export function track(eventName: string, tags: Tags | undefined) {
	TrackingActions.trackComponent(eventName, {
		...tags,
		currentPathName: (window && window.location && window.location.pathname) || "",
	});
}

export const UiTrackedButton = (props: TrackableProps) => {
	const { tags, onClick: innerOnClick, ...innerProps } = props;

	const onClick = (...args) => {
		track("buttonClick", tags);
		if (innerOnClick && typeof innerOnClick !== "undefined") {
			innerOnClick(...args);
		}
	};

	const { "data-testid": dataTestId, className: innerClassName, ...restPropsForButton } = innerProps;
	return (
		<UiButton onClick={onClick} data-testid={dataTestId} className={innerClassName}>
			<button {...restPropsForButton}>{innerProps.children}</button>
		</UiButton>
	);
};
export const TrackedLink = (props: TrackableProps) => {
	const { tags, onClick: innerOnClick, innerRef, ...innerProps } = props;

	const onClick = (...args) => {
		track("linkClick", tags);
		if (innerOnClick && typeof innerOnClick !== "undefined") innerOnClick(args[0]);
	};

	return (
		<a {...(innerProps as any)} onClick={onClick} ref={innerRef}>
			{innerProps.children}
		</a>
	);
};
export const TrackedFormControl = (props: TrackableProps) => {
	const { tags, onBlur: innerOnBlur, innerRef, ...innerProps } = props;

	const onBlur = (...args) => {
		track("formControlBlur", tags);
		if (innerOnBlur && typeof innerOnBlur !== "undefined") innerOnBlur(args[0]);
	};

	return (
		<FormControl {...innerProps} inputRef={innerRef} onBlur={onBlur}>
			{innerProps.children}
		</FormControl>
	);
};
export const TrackedCheckbox = (props: TrackableProps) => {
	const { tags, onChange: innerOnChange, ...innerProps } = props;

	const onChange = (event) => {
		const checked = event.target.checked;
		track("checkboxClick", {
			checked,
			...tags,
		});
		if (innerOnChange && typeof innerOnChange === "function") innerOnChange(event);
	};

	return (
		<Checkbox {...innerProps} onChange={onChange}>
			{innerProps.children}
		</Checkbox>
	);
};
